import { Slide } from "@jelly/lesson";
import config from "appConfig";

const principle: Slide = {
  title: "Equivalent fluid concept",
  layout: {
    type: "customCase010103",
    options: {
      equivalent: {
        note: `Note that the particle velocity is obtained from the volume velocity U and the cross section S by:
        <span style="font-size: 16px">
          <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
            <mi>v</mi>
            <mo>=</mo>
            <mfrac>
              <mi scriptlevel=0>U</mi>
              <mi scriptlevel=0>S</mi>
            </mfrac>
          </math>
        </span>
        .`,
        images: [
          `${config.ASSETS_URL}/01/case-01/slide03-image01.svg`,
          `${config.ASSETS_URL}/01/case-01/slide03-image02.svg`,
          `${config.ASSETS_URL}/01/case-01/slide03-image03.svg`,
        ],
      },
      fromScattering: {
        equationsImages: [
          `${config.ASSETS_URL}/01/case-01/slide03-equation01.svg`,
          `${config.ASSETS_URL}/01/case-01/slide03-equation02.svg`,
          `${config.ASSETS_URL}/01/case-01/slide03-equation03.svg`,
        ],
      },
    },
  },
};

export default principle;
